export const EVALUATOR_PLAYGROUND_BATCH_SIZE = 100;
export const EVALUATOR_PLAYGROUND_BASELINE_SESSION_PROMPT_ID_METADATA_KEY =
  '__ls_eval_prompt_hub_ref';
export const PERCENT_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
